(function () {
  'use strict';

  const STORAGE_KEY = 'shopify_recently_viewed';
  const CARD_SECTION_ID = 'recently-viewed-item';
  const swiperInstances = new WeakMap();

  function getRecentlyViewed() {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function saveRecentlyViewed(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  }

  function trackProductView(handle) {
    if (!handle) return;

    let handles = getRecentlyViewed().filter(function (item) {
      return item !== handle;
    });

    handles.unshift(handle);
    saveRecentlyViewed(handles);
  }

  function getCurrentProductHandle() {
    return document.body.dataset.productHandle || '';
  }

  async function fetchProductSlide(handle) {
    try {
      const response = await fetch(
        '/products/' + encodeURIComponent(handle) + '?section_id=' + CARD_SECTION_ID
      );

      if (!response.ok) {
        return null;
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const card = doc.querySelector('.recently-viewed-item');

      if (!card) {
        return null;
      }

      return (
        '<div class="swiper-slide">' + card.outerHTML + '</div>'
      );
    } catch (e) {
      return null;
    }
  }

  function initSwiper(section) {
    if (!section || typeof Swiper === 'undefined') return;

    const swiperEl = section.querySelector('.featured-collection__swiper');
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    const existing = swiperInstances.get(swiperEl);
    if (existing) {
      existing.destroy(true, true);
      swiperInstances.delete(swiperEl);
    }

    const columns = parseInt(section.dataset.columns, 10) || 4;
    const loop = section.dataset.loop !== 'false' && slides.length > 1;
    const paginationEl = section.querySelector('.featured-collection__pagination');

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 16,
      allowTouchMove: true,
      loop: loop,
      speed: 500,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 22,
        },
        1200: {
          slidesPerView: columns,
          spaceBetween: 24,
        },
      },
    });

    swiperInstances.set(swiperEl, swiper);
  }

  async function renderSection(section) {
    const slidesWrap = section.querySelector('[data-recently-viewed-slides]');
    if (!slidesWrap) return;

    const maxProducts = parseInt(section.dataset.maxProducts, 10) || 4;
    const excludeCurrent = section.dataset.excludeCurrent !== 'false';
    const currentHandle = getCurrentProductHandle();

    let handles = getRecentlyViewed();

    if (excludeCurrent && currentHandle) {
      handles = handles.filter(function (handle) {
        return handle !== currentHandle;
      });
    }

    handles = handles.slice(0, maxProducts);

    if (handles.length === 0) {
      section.hidden = true;
      slidesWrap.innerHTML = '';
      return;
    }

    const slides = await Promise.all(handles.map(fetchProductSlide));
    const validSlides = slides.filter(Boolean);

    if (validSlides.length === 0) {
      section.hidden = true;
      slidesWrap.innerHTML = '';
      return;
    }

    slidesWrap.innerHTML = validSlides.join('');
    section.hidden = false;
    initSwiper(section);

    if (typeof window.refreshWishlistUI === 'function') {
      window.refreshWishlistUI();
    }
  }

  function initAllSections() {
    document.querySelectorAll('[data-recently-viewed]').forEach(renderSection);
  }

  function boot() {
    trackProductView(getCurrentProductHandle());
    initAllSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-recently-viewed]');
    if (section) {
      renderSection(section);
    }
  });
})();
